import { useEffect } from "react";
import Loader from "./Loader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import { initWOW } from "../Utils/wow";

const MissionVision = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const {
    data: visionAndMissionData = [],
    isLoading: visionAndMissionIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "vision_mission",
    lang: languageType,
  });

  useEffect(() => {
    if (!visionAndMissionIsLoading) {
      initWOW();
    }
  }, [visionAndMissionIsLoading]);

  const formatTitle = (title = "") => {
    const words = title.trim().split(" ");

    if (words.length >= 2) {
      return (
        <>
          {words[0]} <span>{words.slice(1).join(" ")}</span>
        </>
      );
    }

    return title;
  };

  if (visionAndMissionIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="corporate-objectives-area corporate-objectives-area2">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 lrspace wow fadeInDown">
              <div className="radius-box one-img overflowDetails">
                <div className="title-sec">
                  <h3
                    className="tittle-mission"
                    aria-label="Corporate Objectives"
                    tabIndex="0"
                  >
                    {/* {  visionAndMissionData[0]?.title} */}
                    {formatTitle(visionAndMissionData[0]?.title)}
                    {/* {getText("Corporate", "कॉर्पोरेट")}
                    <span>{getText("Objectives", "उद्देश्य")}</span> */}
                  </h3>
                </div>
                <div className="txtspace3">
                  <div tabIndex="0">
                    <p
                      className="text-justify"
                      dangerouslySetInnerHTML={{
                        __html:
                          visionAndMissionData[0]
                            ?.field_front_text_of_vision_missi,
                      }}
                    ></p>
                  </div>
                </div>
                <Link
                  to={`/mission-vision/${visionAndMissionData[0]?.nid}`}
                  aria-label={getText(
                    "Learn more about Corporate Objectives",
                    "कॉर्पोरेट उद्देश्यों के बारे में अधिक जानें",
                  )}
                  title={getText(
                    "Learn more about Corporate Objectives",
                    "कॉर्पोरेट उद्देश्यों के बारे में अधिक जानें",
                  )}
                  className="arrow-link"
                >
                  <div className="arrow-rot">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 lrspace2 wow fadeInUp">
              <div className="radius-box two-img overflowDetails">
                <div className="title-sec">
                  <h3
                    className="tittle-mission"
                    aria-label="Our Vision"
                    tabIndex="0"
                  >
                    {/* {  visionAndMissionData[0]?.title} */}
                    {/* {getText("Our", "हमारा")}
                    <span>{getText("Vision", "दृष्टिकोण")}</span> */}
                    {formatTitle(visionAndMissionData[1]?.title)}
                  </h3>
                </div>
                <div className="txtspace3">
                  <div tabIndex="0">
                    <p
                      className="text-justify"
                      dangerouslySetInnerHTML={{
                        __html:
                          visionAndMissionData[1]
                            ?.field_front_text_of_vision_missi,
                      }}
                    ></p>
                  </div>
                </div>
                <Link
                  to={`/mission-vision/${visionAndMissionData[1]?.nid}`}
                  aria-label={getText(
                    "Learn more about Our Vision",
                    "हमारे दृष्टिकोण के बारे में अधिक जानें",
                  )}
                  title={getText(
                    "Learn more about Our Vision",
                    "हमारे दृष्टिकोण के बारे में अधिक जानें",
                  )}
                  className="arrow-link"
                >
                  <div className="arrow-rot">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </Link>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 lrspace3 wow fadeInDown">
              <div className="radius-box three-img overflowDetails">
                <div className="title-sec">
                  <h3
                    className="tittle-mission"
                    aria-label="Our Mission"
                    tabIndex="0"
                  >
                    {formatTitle(visionAndMissionData[2]?.title)}
                    {/* {  visionAndMissionData[0]?.title} */}
                    {/* {getText("Our", "हमारा")}
                    <span>{getText("Mission", "मिशन")}</span> */}
                  </h3>
                </div>
                <div className="txtspace3">
                  <div tabIndex="0">
                    <p
                      className="text-justify"
                      dangerouslySetInnerHTML={{
                        __html:
                          visionAndMissionData[2]
                            ?.field_front_text_of_vision_missi,
                      }}
                    ></p>
                  </div>
                </div>
                <Link
                  to={`/mission-vision/${visionAndMissionData[2]?.nid}`}
                  aria-label={getText(
                    "Learn more about Our Mission",
                    "हमारे मिशन के बारे में अधिक जानें",
                  )}
                  title={getText(
                    "Learn more about Our Mission",
                    "हमारे मिशन के बारे में अधिक जानें",
                  )}
                  className="arrow-link"
                >
                  <div className="arrow-rot">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MissionVision;
